import style from './revenueCard.module.css';

export default function RevenueCard(props) {
    const formattedRevenue = props.revenueAmount
        ? props.revenueAmount.toLocaleString("en-IN")
        : "0"; // fallback if undefined

    return (
        <div className={`${style.revenueCard} p-3 p-lg-4 shadow rounded`}>
            {/* Top Section */}
            <div className="mb-2">
                <div className={`${style.title1} mb-1`}>Revenue</div>
                <div className={`${style.amount} `}>₹ {formattedRevenue}</div>
                <div className={style.lightText}>Last Month</div>
            </div>

            <hr />

            {/* Bottom Section */}
            <div className="d-flex justify-content-between">
                {/* Success */}
                <div className="d-flex align-items-center">
                    <div className="me-2 d-flex align-items-center justify-content-center">
                        {props.successIcon}
                    </div>
                    <div>
                        <div className="fw-bold text-success mb-1 mt-1">15%</div>
                        <div className={style.lightText}>Prev week</div>
                    </div>
                </div>

                {/* Failure */}
                <div className="d-flex align-items-center">
                    <div className="me-2 d-flex align-items-center justify-content-center">
                        {props.FailureIcon}
                    </div>
                    <div>
                        <div className="fw-bold text-danger  mb-1 mt-1">15%</div>
                        <div className={style.lightText}>Prev week</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
